import * as React from 'react';
import { Button, Responsive } from '@cian/ui-kit';

import { IconMapLocation16, IconMapPin16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './LocationButton.css';

interface ILocationButtonProps {
  children: string;
  onClick: () => void;
}

export const LocationButton: React.FC<ILocationButtonProps> = ({ children, onClick }) => {
  return (
    <>
      <Responsive desktop>
        <Button
          beforeIcon={<IconMapLocation16 color="icon-main-default" />}
          theme="fill_white_primary"
          onClick={onClick}
        >
          {children}
        </Button>
      </Responsive>
      <Responsive tablet phone>
        <button className={styles['location-button']} onClick={onClick}>
          <IconMapPin16 color="current_color" />
          {children}
        </button>
      </Responsive>
    </>
  );
};
